import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { KYCOrganism } from 'Components/ComponentLibrary/Organisms/kycOrganism';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { TextButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/TextButtonRel';
import { dataAttrs } from 'Helpers/Testing';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2KYCIntroStepTemplate = ({ resource }) => {
  const { submitPageResource, setPageContentCollection } = usePageContentContext();
  const onKYCFinished = useCallback(async ({ externalID }) => {
    resource.attr('externalId', externalID);
    const { response, error } = await submitPageResource();
    if (!error) {
      setPageContentCollection(response);
    }
    // If there is an error, page context would have already shown a message about it
  }, [resource, submitPageResource, setPageContentCollection]);
  return (
    <WorkflowLayout appearance="elevated" resource={resource}>
      <FDContentContainer maxWidth="sm">
        <FDStack spacing={3} direction="column">
          <MetaControl resource={resource} attrName="title" metaOverrideSet={metaOverrideSet} />
          <MetaControl resource={resource} attrName="description" metaOverrideSet={metaOverrideSet} />
          <KYCOrganism resource={resource} onKYCFinished={onKYCFinished} />
          <TextButtonRel
            {...dataAttrs('cancel-btn', resource)}
            relationship={resource.relationship(fr.relationships.homePage.name)}
            alignSelf="center"
          />
        </FDStack>
      </FDContentContainer>
    </WorkflowLayout>
  );
};

AccountOpeningV2KYCIntroStepTemplate.defaultProps = {
};

AccountOpeningV2KYCIntroStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
